import {Alert, Button, Col, Form, Icon, Input, Modal, notification, Row, Spin} from 'antd'
import {FormComponentProps} from 'antd/lib/form'
import autobind from 'autobind-decorator'
import * as React from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'
import {connect} from 'redux-scaffolding-ts'
import {formatMessage} from 'src/core/services/http.service'
import {NewProjectTaskItem, NewProjectTaskStore} from 'src/stores/projecttasks-store'
import EditableTooltip from '../../../../components/editable-tooltip/tooltip'

let FormItem = Form.Item
let nextId = 1

interface NewProjectTaskViewProps {
	companyId: string
	projectId: string
	onClose: (id: string | undefined, item?: NewProjectTaskItem) => void
    onRefreshRequired?: () => void;
}

interface NewProjectTaskViewState {}

@connect(['newProjectTask', NewProjectTaskStore])
class NewProjectTaskView extends React.Component<
	NewProjectTaskViewProps & WithTranslation & FormComponentProps,
	NewProjectTaskViewState
> {
	private get newProjectTaskStore() {
		return (this.props as any).newProjectTask as NewProjectTaskStore
	}

	constructor(props: NewProjectTaskViewProps & WithTranslation & FormComponentProps) {
		super(props)
		this.newProjectTaskStore.createNew({} as any)
		this.newProjectTaskStore.changeUrl(this.props.companyId, this.props.projectId)

		const keys = this.props.form.getFieldValue('keys')
		this.props.form.setFieldsValue({
			keys: [0]
		})
	}

	componentWillReceiveProps(nextProps: NewProjectTaskViewProps) {
		if (
			this.newProjectTaskStore.state.result &&
			this.newProjectTaskStore.state.result.isSuccess
		)
			nextProps.onClose(
				(this.newProjectTaskStore.state.result as any).aggregateRootId,
				this.newProjectTaskStore.state.item
			)
	}
	@autobind
	private countDownNotification(_notification: any, message: string, description: string, key: string) {
		let secondsToGo = 4;
		_notification({
			key: key,
			message: message + `(${secondsToGo}).`,
			description: description
		});
		const timer = setInterval(() => {
			secondsToGo -= 1;
			_notification({
				key: key,
				message: message + `(${secondsToGo}).`,
				description: description,
				onClose: clearInterval(timer),
			});
		}, 1000);
		setTimeout(() => {
			clearInterval(timer);
			notification.close(key);
		}, secondsToGo * 1000);
	}

	private getIndexOfDuplicate(tasks:any[], task:any) {
		for (var i = 0; i < tasks.length; i++) {
			if (tasks[i].title == task.title)
				return i
		}
		return -1
    }

	private checkDuplicateTasks(tasks: any[]) {
		var checked = new Array()
		tasks.forEach(task => {
			var duplicateIndex = this.getIndexOfDuplicate(checked, task)
			if (duplicateIndex >= 0) {
				checked[duplicateIndex].reference += (' ' + task.reference)
			}
			else {
				checked.push(task)
            }
		});
		return checked
    }

	private onCreateNewItem = () =>
		new Promise((resolve, reject) => {
			this.props.form.validateFields((err, values) => {
				if (!err) {
					const { getFieldDecorator, getFieldValue } = this.props.form
					getFieldDecorator('keys', { initialValue: [] })
					const keys = getFieldValue('keys')
					var tasks = keys.map((v: number, i: number) => {
						return {
							title: values[`n${v}`] as string,
							reference: values[`r${v}`] ? (values[`r${v}`] as string) : '',
							projectId: this.props.projectId
						} as NewProjectTaskItem
					})
					tasks = this.checkDuplicateTasks(tasks)
					tasks.map((task: Partial<NewProjectTaskItem> | undefined) => {
						this.newProjectTaskStore.clear()
						this.newProjectTaskStore.change(task)
						this.newProjectTaskStore
							.submit()
							.then(result => {
								if (result.isSuccess) {
									if (this.props.onRefreshRequired) {
										this.props.onRefreshRequired()
                                    }
									return resolve;
								}
								return reject();
							})
					})
				}
			})
		})

	@autobind
	private onCancelNewItem() {
		this.newProjectTaskStore.clear()
		this.props.onClose(undefined)
	}

	removeTaskItem = (k: number) => {
		const { form } = this.props
		const keys = form.getFieldValue('keys')

		form.setFieldsValue({
			keys: keys.filter((key: number) => key !== k)
		})
	}

	addTaskItem = () => {
		const { form } = this.props
		const keys = form.getFieldValue('keys')
		const nextKeys = keys.concat(nextId++)
		form.setFieldsValue({
			keys: nextKeys
		})
	}

	@autobind
	private buildTaskItem(v: number, idx: number) {
		const { t } = this.props
		const { getFieldDecorator } = this.props.form

		// show Name and Reference labels only for the first task item
		const taskReferenceLabel =
			idx === 0 ? (
				<EditableTooltip name="task-reference"> {t('Reference')} </EditableTooltip>
			) : (
				undefined
			)
		const taskNameLabel = idx === 0 ? t('Task name') : undefined

		return (
			<Row gutter={24} type="flex" align="middle">
				<Col span={11}>
					<FormItem key={`n${v}`} label={taskNameLabel} help={null}>
						{getFieldDecorator(`n${v}`, {
							rules: [
								{ max : 255 },
								{ required: true, message: t('Name required') },
								{ whitespace: true, message: t('Name required') }
							]
						})(<Input placeholder={t('Task name')} type="text" maxLength={255}/>)}
					</FormItem>
				</Col>
				<Col>
					<FormItem key={`r${v}`} label={taskReferenceLabel}>
						{getFieldDecorator(`r${v}`, {})(
							<Input placeholder={t('Optional reference')} type="text" maxLength={255}/>
						)}
					</FormItem>
				</Col>
				<Col>
					{idx !== 0 && (
						<Icon
							type="delete"
							style={{ color: '#d9363e' }}
							onClick={() => this.removeTaskItem(v)}
						/>
					)}
				</Col>
			</Row>
		)
	}

	public render() {
		const { t } = this.props
		const { getFieldDecorator, getFieldValue } = this.props.form
		getFieldDecorator('keys', { initialValue: [] })
		const keys = getFieldValue('keys')

		const formItems = keys.map((k: number, idx: number) => this.buildTaskItem(k, idx))

		return (
			<Modal
				maskClosable={false}
				visible
				onCancel={this.onCancelNewItem}
				onOk={this.onCreateNewItem}
				closable={false}
				width="800px"
				okText={t("OK")}
				cancelText={t("Cancel")}
				title={t('New project task')}>
				{this.newProjectTaskStore.state.result &&
					!this.newProjectTaskStore.state.result.isSuccess && (
						<Alert
							type="error"
							message={t('Error')}
							description={t(formatMessage(this.newProjectTaskStore.state.result))}
						/>
					)}
				<Spin spinning={this.newProjectTaskStore.state.isBusy}>
					<div style={{ height: 250, overflowX: 'hidden', overflowY: 'auto' }}>
						<Form
							style={{ marginRight: 10 }}
							id="newProjectTasksForm"
							onKeyUp={(e) => { if (e.keyCode === 13 && this.onCreateNewItem) { this.onCreateNewItem(); } }}
							onSubmit={this.onCreateNewItem}>
							{formItems}
						</Form>
					</div>
					<Button style={{ marginTop: 10 }} icon="plus" onClick={this.addTaskItem} />
				</Spin>
			</Modal>
		)
	}
}

// Wire up the React component to the Redux store
export default (withTranslation()(Form.create({})(
	NewProjectTaskView as any
) as any) as any) as React.ComponentClass<NewProjectTaskViewProps>
